<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>
<script>
export default {
  name: "App",
  provide() {
    //父组件通过provide来提供变量，在子组件中通过inject来注入变量
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>
<style lang="scss">
.custom-fa541c .el-input__inner {
  border: none;
  background: none;
}
.el-dialog {
  padding-bottom: 30px;
}
#app {
  font: 12px Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  // font: 12px Helvetica Neue,Helvetica,PingFang SC,Tahoma,Arial,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #666;
}
body .el-loading-mask {
  top: 0px !important;
  left: 190px !important;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #666;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.text-right {
  text-align: right;
}
.table-up-btns {
  margin: 10px 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
.el-input.is-disabled .el-input__inner {
  color: #333;
}
.el-table__body-wrapper {
  width: 102% !important;
}
.el-table__fixed-right {
  right: 0px !important;
}
.sidebar-container .el-submenu__icon-arrow {
  right: 28px !important;
}
.toopStyle {
  display: inline-block;
  margin-right: 10px;
}

/*.el-table{*/
/*  width: 102% !important;*/
/*  max-width: 102% !important;*/
/*}*/
/*.width100{*/
/*  width: 100%;*/
/*  overflow: hidden;*/
/*}*/
</style>
